import { el, editable } from './domUtils';

export default class QuickAnswerTool {
  static get toolbox() {
    return {
      title: 'Қисқача жавоб',
      icon: '<svg width="17" height="17" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/><path d="M12 16v-4M12 8h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    };
  }

  static get sanitize() {
    return { text: {} };
  }

  constructor({ data }) {
    this.data = { text: data.text || '' };
  }

  render() {
    this.textEl = editable(this.data.text, 'Саволга қисқа ва тушунарли жавоб...');
    return el('div', { class: 'at-block at-quick-answer' }, [
      el('div', { class: 'at-block-label' }, ['Қисқача жавоб']),
      this.textEl,
    ]);
  }

  save() {
    return { text: this.textEl.innerHTML.trim() };
  }
}
